module.exports = "/_next/static/images/987ed9fb758094fc441635c60c2e5ef1-four-cards.svg.webp";